import {useTranslation} from 'react-i18next'
import {Fact} from '@/components/fact'
import {SectionCard} from '@/components/section-card'
import type {ReporteDatos} from '@/hooks/bateria/use-bateria-informe'
import {formatDateOnly} from '@/lib/risk'

/** Bloque 1 (§P7): los datos que hacen citable el informe. */
export function FichaTecnica({datos}: {datos: ReporteDatos}) {
  const {t} = useTranslation()
  return (
    <SectionCard testId="informe-ficha-tecnica">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        <Fact label={t('admin.bateria.informe.ficha.empresa')}>{datos.empresa_nombre}</Fact>
        <Fact label={t('admin.bateria.informe.ficha.nit')}>
          <span className="font-mono">{datos.empresa_nit}</span>
        </Fact>
        <Fact label={t('admin.bateria.informe.ficha.fechaInicio')}>{formatDateOnly(datos.fecha_inicio)}</Fact>
        <Fact label={t('admin.bateria.informe.ficha.fechaGeneracion')}>{formatDateOnly(datos.fecha_generacion)}</Fact>
        {datos.formas.map((forma) => (
          <Fact key={forma.forma} label={t('admin.bateria.formaValue', {forma: forma.forma})}>
            {t('admin.bateria.informe.ficha.nValidados', {count: forma.n_validados})}
          </Fact>
        ))}
        <Fact label={t('admin.bateria.informe.ficha.psicologa')}>{datos.profesional.nombre}</Fact>
        <Fact label={t('admin.bateria.informe.ficha.licencia')}>
          {datos.profesional.licencia
            ? t('admin.bateria.informe.ficha.licenciaValue', {
                licencia: datos.profesional.licencia,
                fecha: datos.profesional.licencia_fecha ? formatDateOnly(datos.profesional.licencia_fecha) : '',
              }).trim()
            : t('admin.bateria.informe.ficha.sinLicencia')}
        </Fact>
      </div>
    </SectionCard>
  )
}
